import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import injectSheet from "react-jss";
import Select from "../../components/ergo-elements/components/Select";
import { addFocus, routeRest } from "../../utils";
import { i18nHOC } from "../../i18n";
import { DKVGrey } from "../../constants";

const styles = {
  select: {
    width: "50px",
    marginRight: "20px",

    "& select::-ms-value": {
      background: "none",
      color: DKVGrey,
    },
    "& .ee_select, & .ee_select:focus, & .ee_select__control": {
      background: "transparent !important",
    },
    "& .ee_select__toggle-wrapper": {
      width: "12px !important",
      right: "7px !important",
      background: "transparent !important",
      border: "0 !important",
    },
  },
};

export const availableLanguages = ["en", "fr", "nl"];

export default injectSheet(styles)(
  i18nHOC(({ classes, i18n }) => {
    const navigate = useNavigate();
    const location = useLocation();
    return (
      <div className={classes.select}>
        <Select
          onFocus={(e) => addFocus(e)}
          onChange={(e) => {
            navigate(e.target.value, { replace: true, state: location.state });
          }}
          value={location.pathname}
          style={{ width: "50px", border: 0, padding: "4px 20px 4px 4px" }}
        >
          <option value={`/en/${routeRest(location.pathname)}`}>
            {i18n("English")}
          </option>
          <option value={`/fr/${routeRest(location.pathname)}`}>
            {i18n("French")}
          </option>
          <option value={`/nl/${routeRest(location.pathname)}`}>
            {i18n("Dutch")}
          </option>
        </Select>
      </div>
    );
  })
);
